import Mapa from '@componentes/Mapa/Mapa';
import { useEffect, useState } from 'react';
import instance from 'api/instance';
import { CoordinatesData, IncidenciasData, TABLADATA } from '@componentes/Tabla/types';
import useToggle from '@utils/useToggle';
import { formatHora } from '@utils/FormatDate';
import { fetchConfig } from 'api/configService';
import TablaEspecial from '@componentes/TablaEspecial/TablaEspecial';
import { adjustDuplicateCoordinates } from '@utils/duplicateCoordinates';

const tiposa: TABLADATA = {
    datos: []
};

export default function Incidencias() {
    const [incidencias, setIncidencias] = useState<{ id: number, descripcion: string, direccion: string, imagen: string }[]>([]);
    const [tipos, setTipos] = useState(tiposa);
    const [tiposLoaded, setTiposLoaded] = useToggle();
    const [allDataIncidencias, setAllDataIncidencias] = useState<IncidenciasData[]>([]);
    const [coordinates, setCoordinates] = useState<CoordinatesData[]>([]);
    const [marked, setMarked] = useState('');
    const [coordinatesToGo, setCoordinatesToGo] = useState<CoordinatesData>({ lng: 0, lat: 0, id: 0 });
    const [configLoaded, setConfigLoaded] = useToggle(false);
    const [apiUrlConfig, setApiUrlConfig] = useState('');
    const currentDate = new Date();

    useEffect(() => {
        fetchConfig(setApiUrlConfig, setConfigLoaded);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (marked) {
            const value = allDataIncidencias.find(ele => ele.ID_EVENTO === parseInt(marked));
            if (value) {
                setCoordinatesToGo({
                    lng: value.LONGITUD,
                    lat: value.LATITUD,
                    id: value.ID_EVENTO,
                });
            }
        }
    }, [marked, allDataIncidencias]);

    useEffect(() => {
        if (configLoaded) {
            if (!tiposLoaded) {
                const fetchDataTipos = async () => {
                    const apiUrl = `${apiUrlConfig}listaTipo`;
                    instance
                        .get(apiUrl)
                        .then((response) => {
                            setTipos({
                                datos: response.data
                            });
                            setTiposLoaded(true);
                        })
                        .catch((error) => {
                            console.error("Error al hacer la solicitud:", error);
                        });
                };
                fetchDataTipos();
            }

            if (tiposLoaded) {
                const fetchDataIncidencias = async () => {
                    const apiUrl = `${apiUrlConfig}obtenerIncidencias`;
                    instance
                        .get<IncidenciasData[]>(apiUrl)
                        .then((response) => {
                            setIncidencias(
                                formatData(response.data.filter(incidencia => {
                                    const fechaFin = new Date(incidencia.FECHA_FIN);
                                    const fechaInicio = new Date(incidencia.FECHA_INICIO);
                                    const fechaInicioPreaviso = new Date(fechaInicio);
                                    fechaInicioPreaviso.setDate(fechaInicioPreaviso.getDate() - incidencia.PREAVISO);
                                    return fechaFin > currentDate && currentDate > fechaInicioPreaviso;
                                }))
                            );
                            const coordinates = response.data.filter(incidencia => {
                                const fechaFin = new Date(incidencia.FECHA_FIN);
                                const fechaInicio = new Date(incidencia.FECHA_INICIO);
                                const fechaInicioPreaviso = new Date(fechaInicio);
                                fechaInicioPreaviso.setDate(fechaInicioPreaviso.getDate() - incidencia.PREAVISO);

                                return fechaFin > currentDate && currentDate > fechaInicioPreaviso;
                            }).map(ele => {
                                return {
                                    id: ele.ID_EVENTO,
                                    lng: ele.LONGITUD,
                                    lat: ele.LATITUD,
                                    description: ele.DESCRIPCION_EVENTO,
                                    image: `incidencia${ele.TIPO_EVENTO}`,
                                    fechaInicio: ele.FECHA_INICIO,
                                    fechaFin: ele.FECHA_FIN
                                };
                            });
                            setCoordinates(adjustDuplicateCoordinates(coordinates));
                            setAllDataIncidencias(response.data);
                        })
                        .catch((error) => {
                            console.error("Error al hacer la solicitud:", error);
                        });
                };
                fetchDataIncidencias();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tipos, configLoaded, apiUrlConfig]);

    const formatData = (incidenciasToFormat: IncidenciasData[]) => {
        const imagenes = incidenciasToFormat.map(ele =>
            `incidencia${tipos.datos.filter(tipo => tipo.CODIGO === `${ele.TIPO_EVENTO}`)[0].CODIGO}`
        );
        const descripcion = incidenciasToFormat.map(ele => {
            const fechaInicio = new Date(ele.FECHA_INICIO);
            const fechaInicioPreaviso = new Date(fechaInicio);
            fechaInicioPreaviso.setDate(fechaInicioPreaviso.getDate() - ele.PREAVISO);
            return `${(currentDate > fechaInicioPreaviso && currentDate < fechaInicio) ? ele.DESCRIPCION_EVENTO ? `Próxima incidencia: ` :  `Próxima incidencia: Sin datos actualmente` : ''} ${ele.DESCRIPCION_EVENTO}`
        }
        );
        const fechas = incidenciasToFormat.map(ele => {
            const fechaInicio = new Date(ele.FECHA_INICIO);
            const fechaInicioPreaviso = new Date(fechaInicio);
            fechaInicioPreaviso.setDate(fechaInicioPreaviso.getDate() - ele.PREAVISO);
            return ele.FECHA_FIN ? `Desde ${formatHora(ele.FECHA_INICIO)} hasta ${formatHora(ele.FECHA_FIN)}` : `Desde ${formatHora(ele.FECHA_INICIO)}`
        }
        );
        return imagenes.map((ele, index) => {
            return {
                id: incidenciasToFormat[index].ID_EVENTO,
                descripcion: descripcion[index],
                direccion: fechas[index],
                imagen: ele
            };
        })
    };

    return (
        <div className="incidencias">
            {coordinates.length > 0 &&
                <div className="incidencias" style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', maxWidth: '100vw' }}>
                    <div style={{ width: '100%', marginBottom: '20px' }}>
                        <TablaEspecial info={incidencias} setMarked={setMarked} tipo='Incidencias' />
                    </div>
                    <div style={{ width: '100%', marginBottom: '20px' }}>
                        <Mapa height={640} coordinates={coordinates} coordinatesToGo={coordinatesToGo} setMarked={setMarked} />
                    </div>
                </div>
            }
            {
                coordinates.length === 0 &&
                <div style={{ marginBottom: '20px' }}>
                    <h1 style={{ display: 'flex', justifyContent: 'center' }}>No hay incidencias</h1>
                    <TablaEspecial info={[{ id: 1, descripcion: 'Accidente', imagen: '/incidencia1' }, { id: 2, descripcion: 'Obras', imagen: '/incidencia2' }, { id: 3, descripcion: 'Peligro', imagen: '/incidencia3' }]} tipo='Tipos de Incidencia' />
                </div>
            }
        </div>
    );
}
